import { DateValue } from '@/components/ui/date-fields/types';

export function gregorianToHijri(date: DateValue): DateValue {
  const jd = gregorianToJulian(parseInt(date.year), parseInt(date.month), parseInt(date.day));
  const islamic = julianToIslamic(jd);
  
  return {
    year: islamic.year.toString(),
    month: islamic.month.toString(),
    day: islamic.day.toString(),
    type: 'hijri'
  };
}

export function hijriToGregorian(date: DateValue): DateValue {
  const jd = islamicToJulian(parseInt(date.year), parseInt(date.month), parseInt(date.day));
  const gregorian = julianToGregorian(jd);
  
  return {
    year: gregorian.year.toString(),
    month: gregorian.month.toString(), 
    day: gregorian.day.toString(),
    type: 'gregorian'
  };
}

function gregorianToJulian(year: number, month: number, day: number): number {
  const a = Math.floor((14 - month) / 12);
  const y = year + 4800 - a;
  const m = month + 12 * a - 3;
  return day + Math.floor((153 * m + 2) / 5) + 365 * y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;
}

function julianToGregorian(jd: number): { year: number; month: number; day: number } {
  const z = Math.floor(jd + 0.5);
  const a = Math.floor((z - 1867216.25) / 36524.25);
  const b = z + 1 + a - Math.floor(a / 4);
  const c = b + 1524;
  const d = Math.floor((c - 122.1) / 365.25);
  const e = Math.floor(365.25 * d);
  const f = Math.floor((c - e) / 30.6001);

  const day = Math.floor(c - e - Math.floor(30.6001 * f));
  const month = f - 1 - 12 * Math.floor(f / 14);
  const year = d - 4715 - Math.floor((7 + month) / 10);

  return { year, month, day };
}

function julianToIslamic(jd: number): { year: number; month: number; day: number } {
  const l = jd - 1948440 + 10632;
  const n = Math.floor((l - 1) / 10631);
  const l2 = l - 10631 * n + 354;
  const j = Math.floor((10985 - l2) / 5316) * Math.floor((50 * l2) / 17719) + Math.floor(l2 / 5670) * Math.floor((43 * l2) / 15238);
  const l3 = l2 - Math.floor((30 - j) / 15) * Math.floor((17719 * j) / 50) - Math.floor(j / 16) * Math.floor((15238 * j) / 43) + 29;
  const month = Math.floor((24 * l3) / 709);
  const day = l3 - Math.floor((709 * month) / 24);
  const year = 30 * n + j - 30;

  return { year, month, day };
}

function islamicToJulian(year: number, month: number, day: number): number {
  return Math.floor((11 * year + 3) / 30) + 354 * year + 30 * month - Math.floor((month - 1) / 2) + day + 1948440 - 385;
}